<template>
    <el-card>
        <div slot="header">
            Számlázz.hu
            <el-popover
                placement="right"
                width="500"
                trigger="hover">
                    <img :src="helperGif" width="100%" />
                    <span slot="reference">
                        <i class="el-icon-info"></i>
                    </span>
            </el-popover>
        </div>

        <el-form
            ref="szamlazzhuForm"
            :model="formData"
            :rules="rules"
        >
            <el-row :gutter="20">
                <el-col :span="24">
                    <el-form-item
                        label="Számla Agent kulcs"
                        prop="szamlazz_agent_key"
                    >
                        <el-input
                            v-model="formData.szamlazz_agent_key"
                        />
                    </el-form-item>

                    <el-checkbox 
                        v-model="formData.szamlazz_enabled"
                    >Számlázás a Számlázz.hu rendszerén keresztül</el-checkbox>
                </el-col>
            </el-row>
        
        
        </el-form>
    </el-card>
</template>

<script>
export default {
    name: 'szamlazzhu-form',

    props: [
        'ownCompany'
    ],

    data() {
        var requiredIfChecked = (rule, value, callback) => {
            if((typeof value === 'undefined' || value === null || value.trim() === '') && this.formData.szamlazz_enabled === true){
                return callback(new Error('Kérjük töltse ki a Számla Agent kulcs mezőt.'))
            }else{
                callback()
            }
        }

        return {
            formData: {},
            rules: {
                szamlazz_agent_key: [
                    { 
                        validator: requiredIfChecked, 
                        trigger: 'change' 
                    }
                ]
            },
            helperGif: require('../../../../assets/szamlazz-hu-agent-key-helper.gif')
        } 
    },

    watch: {
        ownCompany(newVal) {
            this.formData = Object.assign({}, newVal)
        }
    }

}
</script>